import {
  FooterBsScheduleTableWrapper,
  FooterBsScheduleTr,
  FooterColumnsTitles,
} from './Footer.styled';

import React from 'react';
import dayjs from 'dayjs';
import type { state } from '../../types/store/state';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import type { ScheduleType } from '../../types/branchStoreSchedule';

export const FooterBsSchedule = () => {
  const { t } = useTranslation();

  const branchStoreSchedule = useSelector(
    (storeSchedule: state) => storeSchedule.branchStoreSchedule
  );

  const transformSchedule = (schedule: Array<ScheduleType>) => {
    return schedule.map((entry: any) => ({
      id: entry.id,
      day: entry.day,
      fromTime: entry.fromTime,
      toTime: entry.toTime,
    }));
  };

  const groupSchedule = (
    schedule: Array<{
      id: number;
      day: string;
      fromTime: string;
      toTime: string;
    }>
  ) => {
    const grouped: { days: string[]; time: string }[] = [];
    let currentGroup: { days: string[]; time: string } | null = null;

    if (schedule) {
      schedule.forEach((entry) => {
        if (
          !entry ||
          !entry.fromTime ||
          !entry.toTime ||
          !entry.day
        )
          return;

        const timeRange = `${dayjs(entry.fromTime).format(
          'HH:mm'
        )} - ${dayjs(entry.toTime).format('HH:mm')}`;

        if (!currentGroup || currentGroup.time !== timeRange) {
          currentGroup = { days: [entry.day], time: timeRange };
          grouped.push(currentGroup);
        } else {
          currentGroup.days.push(entry.day);
        }
      });
    }
    return grouped;
  };

  const transformedSchedule = transformSchedule(branchStoreSchedule);

  const groupedSchedule = groupSchedule(transformedSchedule);

  const formatDays = (days: string[]) => {
    const translatedDays = days.map((day) =>
      t(`footer.schedule.description.${day.toLowerCase()}`)
    );
    if (translatedDays.length === 1) return translatedDays[0];
    if (translatedDays.length === 2)
      return `${translatedDays[0]} - ${translatedDays[1]}`;
    return `${translatedDays[0]} - ${translatedDays[translatedDays.length - 1]}`;
  };

  return (
    <div>
      <FooterColumnsTitles>{t('footer.schedule.title')}</FooterColumnsTitles>
      <FooterBsScheduleTableWrapper>
        <table>
          <tbody>
            {groupedSchedule.map((group, index) => (
              <FooterBsScheduleTr key={index}>
                <th align="left">{formatDays(group.days)}</th>
                <td>&nbsp;&nbsp;</td>
                <td>{group.time}</td>
              </FooterBsScheduleTr>
            ))}
          </tbody>
        </table>
      </FooterBsScheduleTableWrapper>
    </div>
  );
};